export const addresses = {
  storeAddress:"0x4DAf17c8142A483B2E2348f56ae0F2cFDAe22ceE",
  tokenAddress:"0x1D13fF25b10C9a6741DFdce229073bed652197c7"
}
